export enum StatementStatus {
    FUTURE = 0,
    ACTUAL = 1,
    SHOULD_FILL = 2,
    EXPIRED = 3,
    FILLED = 4,
}
